<template>
  <v-app>
    <LoadingWidget v-if="loading" />

    <template v-else>
      <v-main>
        <router-view v-bind="$route.meta" />
      </v-main>
    </template>
    <PolicyPrivacyWidget />
  </v-app>
</template>

<script>
import LoadingWidget from "./components/widgets/LoadingWidget.vue";
import PolicyPrivacyWidget from "./components/widgets/PolicyPrivacyWidget.vue";

export default {
  data: () => ({
    loading: true,
  }),
  created() {
    this.updateDocumentTitle();
  },
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    name() {
      return this.informations.name || "";
    },
  },
  methods: {
    updateDocumentTitle() {
      document.title = this.name;
    },
  },
  watch: {
    $route() {
      this.updateDocumentTitle();
    },
    name() {
      this.updateDocumentTitle();
    },
  },

  mounted() {
    this.$rest("informations")
      .get({
        save: (state, data) => (state.item = data),
      })
      .then(() => (this.loading = false));
  },
  components: {
    LoadingWidget,
    PolicyPrivacyWidget,
  },
};
</script>

<style>
.v-application {
  background: #fdfdfd !important;
}
</style>
